module.exports = __webpack_public_path__ + "assets/d81695efb368a57bfbdc76d2fdbaf93b.png";